import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { SITE } from "@/site";
import SEO from "@/components/SEO";

export default function ThankYou() {
    return (
        <div data-testid="page-thank-you" className="relative min-h-[80vh] flex items-center overflow-hidden bg-black">
            <SEO
                title="Thank You | Ihao Music House Delhi"
                description="Thanks for booking a free demo class at Ihao Music House Delhi. Our team will reach out shortly to confirm your slot."
                path="/thank-you"
                noindex
            />
            <div className="absolute inset-0 bg-radial-gold opacity-60" aria-hidden />
            <div className="absolute inset-0 bg-grid opacity-30" aria-hidden />

            <div className="relative max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-24 text-center">
                <div className="mx-auto w-20 h-20 rounded-full border-2 border-gold flex items-center justify-center mb-8">
                    <span className="font-display text-gold text-3xl">✓</span>
                </div>
                <span className="text-[10px] tracking-[0.3em] uppercase text-gold">Submission received</span>
                <h1 className="mt-4 font-display text-4xl md:text-6xl font-bold text-white leading-[1.05]">
                    Thank you. <span className="text-gold italic font-light">We'll call you soon.</span>
                </h1>
                <p className="mt-6 text-white/65 text-base md:text-lg max-w-2xl mx-auto">
                    Your free demo request has been received. A member of our team will reach out within a few hours to confirm your slot. Meanwhile, feel free to drop by or message us.
                </p>

                <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
                    <a href={`tel:${SITE.phone}`} className="rounded-2xl border border-white/10 bg-[#121212] p-6 hover:border-gold/40 transition-colors">
                        <Phone className="w-5 h-5 text-gold mx-auto" />
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mt-3">Call</div>
                        <div className="text-white font-semibold text-sm mt-1">{SITE.phoneIntl}</div>
                    </a>
                    <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="rounded-2xl border border-white/10 bg-[#121212] p-6 hover:border-gold/40 transition-colors">
                        <MessageCircle className="w-5 h-5 text-gold mx-auto" />
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mt-3">WhatsApp</div>
                        <div className="text-white font-semibold text-sm mt-1">Send a message</div>
                    </a>
                    <a href={SITE.mapLink} target="_blank" rel="noreferrer" className="rounded-2xl border border-white/10 bg-[#121212] p-6 hover:border-gold/40 transition-colors">
                        <MapPin className="w-5 h-5 text-gold mx-auto" />
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mt-3">Studio</div>
                        <div className="text-white font-semibold text-sm mt-1">{SITE.addressShort}</div>
                    </a>
                </div>

                <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                    <a
                        href={SITE.whatsapp}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="thankyou-whatsapp-btn"
                        className="inline-flex items-center justify-center bg-[#25D366] text-white font-semibold text-sm px-8 py-4 rounded-full hover:scale-[1.03] transition-transform duration-300"
                    >
                        <MessageCircle className="w-4 h-4 mr-2" />
                        Chat on WhatsApp
                    </a>
                    <Link to="/" className="inline-flex items-center justify-center border border-white/20 text-white font-semibold text-sm px-8 py-4 rounded-full hover:bg-white/5 transition-colors">
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
}
